module.exports = __webpack_public_path__ + "static/media/Cera-Pro-Light.35ffb6f1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/Cera-Pro-Light.woff
// module id = 163
// module chunks = 56